import { AxiosError, AxiosInstance } from 'axios';
import { getExportConfig, handleFileExport } from '../../../../../../helpers/fileExport';
import { DAILY_REPORT_ENDPOINT } from '../endpoint';
import { DailyReportRequestModel } from '../models/DailyReportPageRequestModel';

export const exportPDF =
  (axios: AxiosInstance) =>
  async (params?: DailyReportRequestModel): Promise<void> => {
    return await axios
      .post(
        `${DAILY_REPORT_ENDPOINT}`,
        {
          comment: params?.comment,
          date: params?.date,
        },
        {
          params: { ...params },
          ...getExportConfig(params),
        }
      )
      .then(response => {
        handleFileExport(response, {
          file_type: params?.file_type,
          filename: 'daily-report',
        });
      });
  };

export const saveComment = (axios: AxiosInstance) => async (data: DailyReportRequestModel) => {
  try {
    const response = await axios.put(`${DAILY_REPORT_ENDPOINT}`, {
      date: data.date,
      comment: data.comment,
    });

    if (response.data) {
      console.log('Response Data:', response.data);
    }

    if (!response.data) {
      throw new Error('No response data');
    }

    if (response.status !== 200) {
      throw new Error(`Failed to save comment: ${response.statusText}`);
    }

    return response.data;
  } catch (err) {
    const error = err as AxiosError;
    console.error('Save Comment Error:', {
      message: error.message,
      status: error.response?.status,
      statusText: error.response?.statusText,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const getComment = (axios: AxiosInstance) => async (data: { date: string }) => {
  try {
    const response = await axios.get(`${DAILY_REPORT_ENDPOINT}`, {
      params: { date: data.date },
    });

    if (response.data) {
      console.log('Response Data:', response.data);
    }

    if (!response.data) {
      throw new Error('No response data');
    }

    if (response.status !== 200) {
      throw new Error(`Failed to get comment: ${response.statusText}`);
    }

    return response.data;
  } catch (err) {
    const error = err as AxiosError;
    console.error('Get Comment Error:', {
      message: error.message,
      status: error.response?.status,
      statusText: error.response?.statusText,
      headers: error.response?.headers,
    });
    throw error;
  }
};
